import { render, staticRenderFns } from "./ModalModify.vue?vue&type=template&id=24b523ac&scoped=true&"
import script from "./ModalModify.vue?vue&type=script&lang=js&"
export * from "./ModalModify.vue?vue&type=script&lang=js&"
import style1 from "./ModalModify.vue?vue&type=style&index=1&id=24b523ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b523ac",
  null
  
)

export default component.exports